import React from 'react'
import './index.sass'

const VideoSliderThumb = ({ description, thumb, id, handleChangeSlide, isActive }) => (
  <div className="video-thumb">
    <p className="subtitle-2">{description}</p>
    <div className="mask" onClick={() => handleChangeSlide(id)}>
      <div className={isActive ? 'mask-wrapper mask-wrapper-active' : 'mask-wrapper'}>
        <p className="subtitle-2">Playing...</p>
      </div>
      <img alt={thumb} src={thumb} />
    </div>
  </div>
)

export default VideoSliderThumb
